"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetPeriodEnum = void 0;
var BudgetPeriodEnum;
(function (BudgetPeriodEnum) {
    BudgetPeriodEnum[BudgetPeriodEnum["MONTHLY"] = 0] = "MONTHLY";
    BudgetPeriodEnum[BudgetPeriodEnum["QUARTERLY"] = 1] = "QUARTERLY";
    BudgetPeriodEnum[BudgetPeriodEnum["YEARLY"] = 2] = "YEARLY";
})(BudgetPeriodEnum || (exports.BudgetPeriodEnum = BudgetPeriodEnum = {}));
